export const data = {
    type_of_payment: '',
    vendor_code: '',
    vendor_name: '',
    vendor_id: '',
    po_number: null,
    tds_liability: '',
    it_section_applicable: '',
    beneficiary_name: '',
    bank_acc_number: '',
    ifsc_code: '',
    bank_name: '',
    invoice_number: null,
    expenditure_month: [],
    date_of_invoice: null,
    bill_availability: '',
    narration: '',
    mode_of_payment: '',
    invoice_soft_copy_link: '',
    supporting_document_link: '',
    max_character_limit: 165,
    vendor_ldc_data: null,
    gstn: '',
    bill_type: '',
    business_unit: '',
  }


// WEBPACK FOOTER //
// ./src/component-data/paymentrequest-data/PaymentRequest.js